
import AddJobFamForm from "../../components/Forms/AddJobFamForm";
import BasicCard  from "../BasicCard";

import Dummylayout from "../Dummylayout";



function AddJobFam() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AddJobFamForm/>
            </BasicCard>
        </>
    )
}
export default AddJobFam;